module.exports = __webpack_public_path__ + "img/violenceSurvey.f986e9a7.svg";